// extracted by mini-css-extract-plugin
module.exports = {"uiSpinner":"Rbj","primary":"Rbl","gray":"Rbn","sm":"Rbp","md":"Rbr","lg":"Rbt","spin":"Rbv"};